import { TRACKERS } from "@/constants/Trackers";
import { QuickView } from "@/features/Patient/MedicalRecords/QuickView/QuickView";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/quick-view")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_QUICK_VIEW);
  },
});

function RouteComponent() {
  return <QuickView />;
}
